import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    logoutAction,
    Logout
} from '../store/actions/AuthActions';
import useRequestsWOAccessToken from '../utils/useRequestsWOAccessToken';

export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function login(email, password) {
    // const postData = {
    //     email,
    //     password,
    //     returnSecureToken: true,
    // };
    // return axios.post(
    //     `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    //     postData,
    // );
}

export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
           swal("Oops", "Email not found", "error",{ button: "Try Again!",});
           break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error",{ button: "Try Again!",});
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    localStorage.setItem('organizerDetails', JSON.stringify(tokenDetails));
    localStorage.setItem('organizerName', JSON.stringify(tokenDetails.displayName));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        let locationState = { code: 200, status: 'success', message: 'You have been logged out due to inactivity.' }
        dispatch(Logout(navigate, locationState));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('organizerDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        let locationState = { code: 200, status: 'success', message: 'You have been logged out due to details not found.' }
        dispatch(Logout(navigate, locationState));
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        let locationState = { code: 200, status: 'success', message: 'You have been logged out due to token expiry.' }
        dispatch(Logout(navigate, locationState));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
	
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}
